import { type SlideData } from "photoswipe";

export const createCustomGalleryElement = (data: SlideData, close: () => void) => {
    const originalSrc = data.src;
    const webpSrc = data.msrc;

    const pictureElement = document.createElement("picture");

    const sourceWebp = document.createElement("source");
    sourceWebp.srcset = webpSrc;
    sourceWebp.type = "image/webp";

    const sourceJpg = document.createElement("source");
    sourceJpg.srcset = originalSrc;
    sourceJpg.type = "image/jpeg";

    const imgElement = document.createElement("img");
    imgElement.src = originalSrc;
    imgElement.setAttribute("alt", data.alt);
    imgElement.className = "pswp__img";

    pictureElement.appendChild(sourceWebp);
    pictureElement.appendChild(sourceJpg);
    pictureElement.appendChild(imgElement);

    const tittle = data.element.querySelector(".pswp-gallery__image-title")?.innerHTML || "";
    const captionElement = document.createElement("figcaption");
    captionElement.className = "pswp__caption";
    captionElement.innerHTML = tittle;

    const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgElement.setAttribute("viewBox", "0 0 24 24");
    svgElement.setAttribute("width", "24");
    svgElement.setAttribute("height", "24");
    svgElement.innerHTML =
        '<path fill="currentColor" fill-rule="evenodd" d="M3.293 3.293a1 1 0 0 1 1.414 0L12 10.586l7.293-7.293a1 1 0 1 1 1.414 1.414L13.414 12l7.293 7.293a1 1 0 0 1-1.414 1.414L12 13.414l-7.293 7.293a1 1 0 0 1-1.414-1.414L10.586 12 3.293 4.707a1 1 0 0 1 0-1.414Z" clip-rule="evenodd"/>';

    const closeElement = document.createElement("div");
    closeElement.className = "pswp__custom-button ds-icon";
    closeElement.setAttribute("title", "Close (Esc)");
    closeElement.setAttribute("aria-label", "Close (Esc)");
    closeElement.appendChild(svgElement);
    closeElement.addEventListener("click", close);

    const figureElement = document.createElement("figure");
    figureElement.className = "pswp__img-wrap";
    figureElement.appendChild(pictureElement);
    figureElement.appendChild(captionElement);
    figureElement.appendChild(closeElement);

    return figureElement;
};
